<template>
  <div>
    <div class="ValidatorBetail">
      <div class="ValidatorBetail-W">
        <div class="Homeinput"></div>
        <div class="BkHeight_conent">
          <div class="BkHeight_conent_header">
            <p>
              <span>Overview</span>
            </p>
          </div>
          <div class="BkHeight_conent_Ul">
            <ul>
              <li>
                <p>Token :</p>
                <p>
                  <img src="@/assets/pc/Index/amount.png" /> SHIBA INU (SHIB)
                </p>
              </li>
              <li>
                <p>Supply :</p>
                <p>99,885,965,228</p>
              </li>
              <li>
                <p>Transactions :</p>
                <p>5,044,012</p>
              </li>
              <li>
                <p>Contract :</p>
                <p>0xB8c77482e45F1F44dE1745F52C74426C631bDD52</p>
              </li>
              <li>
                <p>Holders :</p>
                <p>91,854s</p>
              </li>
              <li>
                <p>Creator :</p>
                <p>ds56dgf6g56sd5fg6sf5s6f5s6f5sd65fs</p>
              </li>
            </ul>
          </div>
        </div>
        <div>
          <TokensList></TokensList>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Listbox from "@/components/pc/Listbox.vue";
import Homseach from "@/components/pc/serch.vue";
import Homeinput from "../Home/Home_input.vue";
import TokensList from "./Contractsdetaillist.vue";
export default {
  data() {
    return {};
  },
  components: {
    Homeinput,
    Homseach,
    Listbox,
    TokensList,
  },
  methods: {},
};
</script>

<style lang="less" scoped>
.ValidatorBetail {
  width: 100%;
  background: #13161b;
  .ValidatorBetail-W {
    width: 1160px;
    margin: 0 auto;
    background: #13161b;
    .Homeinput {
      padding: 10px 0;
    }
    .BkHeight_conent {
      background: #0b0c0f;
      border-radius: 16px 16px 16px 16px;
      padding: 20px 20px 0 20px;
      margin-bottom: 20px;
      .BkHeight_conent_header {
        p {
          span:nth-child(1) {
            font-size: 18px;
            font-family: Source Han Sans CN-Medium, Source Han Sans CN;
            font-weight: 500;
            color: #ffffff;
            line-height: 24px;
            -webkit-background-clip: text;
            margin-left: 40px;
            margin-top: 40px;
          }
        }
      }

      .BkHeight_conent_Ul {
        margin-left: 40px;
        ul {
          li {
            display: flex;
            height: 62px;
            p:nth-child(1) {
              flex: 0 0 12%;
              font-size: 14px;
              font-family: Source Han Sans CN-Regular, Source Han Sans CN;
              font-weight: 400;
              color: #898b8d;
              line-height: 62px;
              -webkit-background-clip: text;
              margin-right: 161px;
            }
            p:nth-child(2) {
              flex: 0 0 60%;
              font-size: 14px;
              font-family: Source Han Sans CN-Regular, Source Han Sans CN;
              font-weight: 400;
              color: #898b8d;
              line-height: 20px;
              line-height: 62px;
              -webkit-background-clip: text;
              img {
                width: 26px;
                height: 26px;
                margin-top: 20px;
              }
            }
          }
          li:nth-child(2) {
            p {
              img {
                width: 24px;
                height: 24px;
                margin-left: 20px;
                cursor: pointer;
              }
            }
          }
          li:nth-child(6) {
            p:nth-child(2) {
              color: #fff;
              font-size: 14px;
              font-family: Source Han Sans CN-Regular, Source Han Sans CN;
              font-weight: 400;
              cursor: pointer;
            }
            p:nth-child(2):hover{
              color: #00a870 !important;
            }
          }
          li:nth-child(7) {
            p:nth-child(2) {
              color: #00a870;
            }
            .active {
              color: #e34d59 !important;
            }
          }
        }
      }
    }
    .TopValidatorsList {
      padding-bottom: 40px;
    }
  }
}
.BlockList {
  width: 100%;
  background: #13161b;
  .BlockList-W {
    width: 1200px;
    margin: 0 auto;
    padding-bottom: 36px;
    background: #13161b;
    .BlockList_Inp {
      padding: 40px 0;
    }
    .Blockbox {
      margin-bottom: 20px;
      display: flex;
      .box1 {
        width: 295px !important;
      }
      .box2 {
        width: 476px !important;
      }
      .box3 {
        width: 349px !important;
      }
      .Blockboxli {
        width: 373px;
        height: 120px;
        background: #0b0c0f;
        border-radius: 6px 6px 6px 6px;
        opacity: 1;
        margin-right: 20px;
        .Blocktit {
          font-size: 12px;
          font-family: Source Han Sans CN-Regular, Source Han Sans CN;
          font-weight: 400;
          color: rgba(255, 255, 255, 0.5);
          line-height: 17px;
          margin-top: 30px;
          margin-left: 40px;
        }
        .Blockcon {
          height: 35px;
          font-size: 24px;
          font-family: Source Han Sans CN-Medium, Source Han Sans CN;
          font-weight: 500;
          color: #00e79a;
          line-height: 35px;
          margin-top: 8px;
          margin-left: 40px;
        }
      }
    }
  }
}
</style>
